var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polyline, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 86.6 80.19 80.19",
    width: 80.19,
    height: 80.19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1,
    cy: 126.67,
    r: 38.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.26,135.54c.22.44.42.99.5,1.61.14,1.05-.11,1.87-.22,2.28-.51,1.87-.88,4.97-.17,7.03.7,2.02,2.48,3.13,3.52,3.77,5.61,3.49,13.1.33,14.02-.07,1.19,2.42,1.62,4.48,1.77,5.98.32,3.11-.32,5.64.98,6.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.67,89.86c-.08,1.21-.36,2.97-1.33,4.82-.45.87-.95,1.42-1.91,2.72-1.37,1.85-2.76,3.5-4.1,4.98.01.69.06,1.53.45,2.37.64,1.38,2.1,3.15,5.41,4.69.32.77.44,1.44.5,1.9.05.42.24,2.13-.68,3.81-.07.13-.19.33-.36.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1,109.42s1.87.72,4.3-.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.43,106.66s2.98-1.87,6.39.99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.79,150.21s11.6-3.73,21.5-8.73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.32,120.78c2.49-.37,6.43.44,12.66,4.32,0,0,1.3.45,1.48,1.43.16.89-.57,1.61-.93,1.96-.79.76-1.67.98-2.86,1.27-3.44.81-5.2,1.22-7.05,1.37-1.04.08-1.9.11-2.48.11-.62.8-1.39,1.35-2.5,1.32,0,0-.01,0-.02,0-.06.24-.15.73.03,1.29.16.48.44.77.62.96.34.35.69.54.91.64.46.21.89.35,1.36.43.28.05,1,.14,3.32-.17.79-.11,1.19-.16,1.61-.27.73-.19,1.34-.5,2.16-.84,1.32-.56,2.24-1.13,3.33-2.03.89-.74,2.67-2.25,3.52-4.83.27-.83.38-1.55.43-2.04-2.42-1.97-4.24-3.65-5.49-4.87,0,0-2.13-2.53-5.52-4.44-.62-.35-1.15-.61-1.51-.77-.45-.16-1.04-.3-1.72-.34-1.03-.06-2.41.11-3.79,1.02,0,0-1.87-1.7-3.97.68-.02.74-.04,1.48-.06,2.21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.98,121.25c.08.22.18.48.22.62.11.34.24.83.28,1.47-.31.08-.78.15-1.33.05-.21-.04-.39-.09-.54-.15-.33-.54-.72-1.12-1.19-1.71-.14-.17-.28-.34-.41-.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.29,129.27s-4.01-.48-9.01-1.44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.43,125.52c2.34.42,5.55.95,10.8,1.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75,119.04l1.7-.42,1.56-.07,8.07,1.83,1.36.37s3.04,1.68,2.83,6.09c0,0-.71,4.55-4.22,5.44l-10.86-2.07-2.04-.82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45,116.29l18.86,2.94s3.23,2.09,2.28,6.17c0,0-1.22,3.23-3.99,4.11"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "19.87 129.4 8.03 127.83 2.45 127.11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.02,121.41l.53,1.75.86.63,1.58-.27.3-1.18.43,1.45s.27.39.78.36l.51-.03.66.39,1.06-.36.1-.17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.12,123.69c.93-1.78,2.52-4.3,5.11-6.77,2.17-2.06,4.18-2.23,6.64-4.6,1.74-1.67,2.81-3.4,3.45-4.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.5adffb8b8ba9f611e82bee238b0be59b.svg";
export { ForwardRef as ReactComponent };